import * as React from 'react';
export const bancontactSvg = React.forwardRef(function bancontactSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M1.316 8.01h4.362l4.325-5.153A2.288 2.288 0 0 1 11.774 2H24.7c.718 0 1.3.616 1.3 1.375v4.3c0 .76-.582 1.375-1.3 1.375h-4.195l-3.342 4.093a2.288 2.288 0 0 1-1.77.857H1.3C.582 14 0 13.384 0 12.625v-3.3A1.3 1.3 0 0 1 1.316 8.01zm19.918 0L24.75 8c.144 0 .25-.123.25-.275V3.3c0-.152-.106-.3-.25-.3H11.691c-.378 0-.737.274-.984.576l-.51.624h-.01l-5.534 6.793h6.054l4.685-5h7.754z',
      fillRule: 'evenodd',
    }),
  );
});
bancontactSvg.defaultProps = {
  height: '16',
  viewBox: '0 0 26 16',
  width: '26',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var bancontact = {
  category: 'paymentmethod',
  colorable: true,
  name: 'bancontact',
  svg: bancontactSvg,
};
